import React from "react";

export const Image5 = ({ title5, largeImage5, smallImage5 }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage5} title5={title5} data-lightbox-gallery="gallery5">
          <div className="hover-text">
            <h4>{title5}</h4>
          </div>
          <img src={smallImage5} className="img-responsive" alt={title5} />{" "}
        </a>{" "}
        
      </div>
    </div>
    
  );
};
